import { useToast } from '../context/ToastContext';

export function Toast() {
  const { toast } = useToast();
  if (!toast) return null;

  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50 max-w-[calc(100vw-40px)] rounded-full bg-atlas-ink dark:bg-atlas-ink-dark text-atlas-bg dark:text-atlas-bg-dark px-6 py-3 text-sm font-semibold shadow-lg text-center whitespace-nowrap animate-fade-in">
      {toast}
    </div>
  );
}
